import { render, staticRenderFns } from "./BackgroundPositionSetting.vue?vue&type=template&id=e81547f8"
import script from "./BackgroundPositionSetting.vue?vue&type=script&lang=js"
export * from "./BackgroundPositionSetting.vue?vue&type=script&lang=js"
import style0 from "./BackgroundPositionSetting.vue?vue&type=style&index=0&id=e81547f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VBtnToggle,VIcon})
